export default "__VITE_ASSET__b62ac78d__"